export default "__VITE_ASSET__Bx3vN5XS__"